<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ settings[ mode ].caption }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                      placeholder="Название доски"
                      persistent-hint
                      class="kanban-section-input"
                      v-model="board.name"
                      ref="name"
                      autofocus
              ></v-text-field>
              <v-textarea
                      label="Описание доски"
                      rows="4"
                      class="kanban-card-edit-textarea"
                      v-model="board.description"
              ></v-textarea>
              <v-flex xs12 sm6 d-flex v-if="false">
                <v-select
                      :items="types.map( type => type.name )"
                      label="Тип доски"
                      v-model="boardType"
                ></v-select>
              </v-flex>
            </v-flex>
            <v-flex xs4 pl-4 v-if="false">
              <v-btn block class="kanban-btn-cancel" @click="">Бизнес-процесс</v-btn>
              <v-btn block class="kanban-btn-cancel" @click="">Метки</v-btn>
              <v-btn block class="kanban-btn-cancel" @click="">Срок</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="kanban-btn-cancel" @click="dialog = false">Закрыть</v-btn>
        <v-btn class="kanban-btn-ok" @click="ok()">Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  /**
   *
   *
   */
  const createMode = {
    caption: 'Создание новой доски',
    options: {}
  }

  /**
   *
   *
   */
  const editMode = {
    caption: 'Редактирование доски',
    options: {}
  }

  /**
   *
   *
   */
  const boardTypes = [
    {
      type: 10,
      name: 'Личная доска'
    },
    {
      type: 20,
      name: 'Бизнес-процесс'
    },
    {
      type: 30,
      name: 'Публичная доска'
    }
  ]



  /**
   *
   *
   */
  export default {

    name: 'DBoardEditDialog',

    componentName: "DBoardEditDialog",

    /**
     *
     *
     */
    props: {

      editBoard: {
        type: Object,
        required: false
      }
    },

    /**
     *
     *
     */
    mounted() {

      this.$refs.name.focus()
    },

    /**
     *
     *
     */
    data() {

      return {

        dialog: false,

        mode: 'create',

        settings: {

          create: createMode,

          edit: editMode
        },

        board: {},

        boardType: '',

        types: boardTypes
      }
    },

    /**
     *
     *
     */
    watch: {

      editBoard: {

        handler( editBoard ) {

        },

        immediate: true
      }
    },

    /**
     *
     *
     */
    computed: {

    },

    /**
     *
     *
     */
    methods: {

      /**
       *
       *
       */
      show() {

        this.board = Object.assign( {}, this.editBoard )
        this.boardType = this.types.find( boardType => boardType.type == this.board.type ).name

        this.mode = (typeof this.board.id === 'undefined') ? 'create' : 'edit'
        this.dialog = true
      },

      /**
       *
       *
       */
      hide() {

        this.dialog = false
      },

      /**
       *
       *
       */
      ok() {

        this.dialog = false

        let boardType = this.types.find( type => type.name === this.boardType )

        this.board.type = boardType.type

        this.$emit( 'ok', this.board, this.mode )
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/DKanban/src/DBoardEditDialog.vue